import { Vue, Options } from 'vue-class-component';

@Options({
  name: 'CardContainer',
  components: {},
  props: {
    titleIcon: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    showActionButton: {
      type: Boolean,
      required: false,
    },
    actionButtonLabel: {
      type: String,
      required: false,
    },
    disabled: {
    type:Boolean,
    required: false, 
    default: false

    }
  },
  watch: {},
  emits: ['on-Action-Button-Click']
})

export default class CardContainer extends Vue {
  titleIcon!: string;
  title!: string;
  showActionButton!: boolean;
  actionButtonLabel!: string;
  disabled!:boolean;



  onActionButtonClick () {
    this.$emit('on-Action-Button-Click');
  }
}
